/**
 * Generate a help URL for the given slug
 *
 * @param slug - The slug to generate a help URL for
 * @returns The generated help URL
 * @internal
 */
export function generateHelpUrl(slug: string): string {
  return `https://www.sanity.io/help/${slug}`
}
